import { assistanceRequest, getCurrentApplicationName } from '../Utility'

/**
 * Componente pulsante per richiedere assistenza.
 *
 * Cliccando il pulsante crea una nuova email all'indirizzo assistenza@starinfostudio.it con il nome dell'applicazione
 * corrente come oggetto e attiva la funzione {@link assistanceRequest} per inviare uno screenshot
 * della pagina corrente allo stesso indirizzo email.
 *
 * @param {string} [buttonTitle] - testo da visualizzare sul pulsante
 * @returns {JSX.Element} - elemento pulsante
 */
export function ButtonAssistance({ buttonTitle }) {
  /**
   * Crea un link mailto per aprire la pagina email del client
   * con oggetto "Richiesta assistenza" e nome dell'applicazione corrente
   * e richiama la funzione {@link assistanceRequest} per inviare
   * uno screenshot della pagina corrente alla stessa email.
   */
  const onClick = () => {
    const link = document.createElement('a')
    const applicationName = getCurrentApplicationName()
    link.href = `mailto:assistenza@starinfostudio.it?
        subject=${applicationName.toUpperCase()} - Richiesta assistenza`
    document.body.appendChild(link)
    link.click()
    assistanceRequest(applicationName)
  }

  return (
    <button className="btn btn-primary" onClick={onClick}>
      <i className="star-icon-question star-icon me-2" />
      {buttonTitle || 'Richiedi assistenza'}
    </button>
  )
}
